/**
 * WaterResourceRerunPanel — thin wrapper around FeasibilityRerunPanel with
 * water-domain gap categorization (Supply / Rights / Discharge / Drought).
 * Workflow Prompt 6.
 */
import React from 'react';
import { FeasibilityRerunPanel, type RerunPanelProps, type DataGapItem } from './FeasibilityRerunPanel';
import { getGapCategoriesForType } from '../../../lib/rerunGapCategories';

export function WaterResourceRerunPanel(props: RerunPanelProps) {
  return (
    <FeasibilityRerunPanel
      {...props}
      gapCategorizer={(gaps: DataGapItem[]) => getGapCategoriesForType('water-resource', gaps)}
    />
  );
}
